import { render, staticRenderFns } from "./VehicleTrip.vue?vue&type=template&id=da43be9a&"
import script from "./VehicleTrip.vue?vue&type=script&lang=js&"
export * from "./VehicleTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports